import { CV } from "@/data/cv";

export default function Expertise() {
  return (
    <section id="expertise" data-testid="expertise-section" className="py-24 md:py-32 border-b-2 border-black">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <p className="font-mono-acc text-xs text-[#525252] mb-4">// 05 — Expertise</p>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
              Ex<span className="text-[#FF3B00]">pertise.</span>
            </h2>
          </div>
          <p className="font-mono-acc text-[11px] md:text-xs text-[#525252] max-w-sm">
            Skill-Set zwischen Plattform-Native, Performance und Brand. Plus drei Sprachen.
          </p>
        </div>

        {/* Skills als ruhige Chip-Reihe */}
        <div data-testid="skills-chips" className="flex flex-wrap gap-2 md:gap-3">
          {CV.skills.map((s) => (
            <span
              key={s}
              className="font-mono-acc text-[11px] md:text-xs px-4 py-2.5 border-2 border-black bg-white hover:bg-black hover:text-white transition-colors"
            >
              {s}
            </span>
          ))}
        </div>

        {/* Sprachen */}
        <div className="mt-16">
          <p className="font-mono-acc text-xs text-[#525252] mb-4">// Sprachen</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-black border-2 border-black">
            {CV.languages.map((l, i) => (
              <div
                key={l.name}
                data-testid={`language-${i}`}
                className="bg-[#F4F4F0] p-6 md:p-8 hover:bg-black hover:text-[#F4F4F0] transition-colors group"
              >
                <div className="font-display uppercase text-2xl md:text-3xl">{l.name}</div>
                <div className="mt-2 font-mono-acc text-[10px] text-[#525252] group-hover:text-[#F4F4F0]/70">
                  {l.level}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
